<template>
	<div class="audio-player">
		<div class="audio-progress" :style="`right: ${audioPercentage}%`"></div>
		<div class="audio-loading" v-if="!audioReady">
			<fa-icon class="faicon" icon="circle-notch" spin />
		</div>
		<div class="audio-player-container" v-if="audioReady">
			<div class="audio-player-controls">
				<fa-icon class="faicon" v-if="!audioPlaying" icon="play" @click="playAudio()" />
				<fa-icon class="faicon" v-if="audioPlaying" icon="pause" @click="pauseAudio()" />
				<fa-icon class="faicon" :class="{'faicon-disabled' : !audioPlaying && audioTime <= 0}" icon="backward" @click="stopAudio()" />
			</div>
			<div class="audio-player-info">{{translateTrackName}}</div>
		</div>
	</div>
</template>

<script>
import propIdMixin from '@/views/prop-id-mixin';
import staticDataLoaderMixin from '@/store/modules/staticData/static-data-loader';
import contentDataLoaderMixin from '@/store/modules/contentData/content-data-loader';

export default {
	name: 'AudioPlayer',
	mixins: [propIdMixin, staticDataLoaderMixin, contentDataLoaderMixin],
	data() {
		return {
			media: null,
			audioReady: false,
			audioSource: null,
			audioPlaying: false,
			audioTime: -1,
			audioPercentage: 100,
			uid: Math.random() * 10000000,
		};
	},
	props: {
		autoplay: {
			type: [Boolean],
			default: false,
		},
	},
	created() {
		// get the media object
		const tempMedia = Object.assign({}, this.getContentById('media', this.pid));
		// get the path
		const fileURI = `/storage/media/${tempMedia.original_name}`;
		// load the audio and set up the listeners
		this.audioSource = new Audio(fileURI);
		this.audioSource.addEventListener('canplaythrough', this.canplaythroughListener, false);
		this.audioSource.addEventListener('timeupdate', this.timeupdateListener, false);

		// parse media description
		// tempMedia.name = JSON.parse(tempMedia.name)[this.language];

		// bind the data (prevents infinite loops because of the tempMedia.name parsing)
		this.media = tempMedia;

		// register the audio listener
		this.$root.$on('audio-played', this.audioplayedListener);
	},
	beforeDestroy() {
		// clean house
		this.audioSource.pause();
		this.audioSource.removeEventListener('canplaythrough', this.canplaythroughListener);
		this.audioSource.removeEventListener('timeupdate', this.timeupdateListener);
		this.audioSource = null;
		this.$root.$off('audio-played', this.audioplayedListener);
	},
	computed: {
		translateTrackName() {
			return JSON.parse(this.media.name)[this.language];
		},
	},
	methods: {
		canplaythroughListener() {
			this.audioReady = true;
			if (this.autoplay) {
				this.playAudio();
			}
		},
		timeupdateListener() {
			this.audioTime = this.audioSource.currentTime;
			this.audioPercentage = 100 - ((this.audioSource.currentTime / this.audioSource.duration) * 100);
		},
		audioplayedListener(e) {
			if (e.id !== this.uid) {
				this.pauseAudio();
			}
		},
		stopAudio() {
			this.audioSource.currentTime = 0;
			this.audioSource.pause();
			this.audioPlaying = false;
		},
		pauseAudio() {
			this.audioSource.pause();
			this.audioPlaying = false;
		},
		playAudio() {
			this.audioSource.play();
			this.audioPlaying = true;
			this.$root.$emit('audio-played', { id: this.uid });
		},
	},
};
</script>

<style src="@/styles/components/AudioPlayer/AudioPlayer.less" lang="less" scoped></style>
